"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_SECP_SIG = exports.EMPTY_WITNESS_ARGS = exports.PERSONAL = void 0;
exports.PERSONAL = new Uint8Array([99, 107, 98, 45, 100, 101, 102, 97, 117, 108, 116, 45, 104, 97, 115, 104]);
exports.EMPTY_WITNESS_ARGS = {
    lock: '',
    inputType: '',
    outputType: '',
};
exports.EMPTY_SECP_SIG = `0x${'0'.repeat(130)}`;
exports.default = {
    PERSONAL: exports.PERSONAL,
    EMPTY_WITNESS_ARGS: exports.EMPTY_WITNESS_ARGS,
    EMPTY_SECP_SIG: exports.EMPTY_SECP_SIG,
};
//# sourceMappingURL=const.js.map